import { render, staticRenderFns } from "./GlobalNotificationsFloating.vue?vue&type=template&id=701a09e4&scoped=true"
import script from "./GlobalNotificationsFloating.vue?vue&type=script&lang=js"
export * from "./GlobalNotificationsFloating.vue?vue&type=script&lang=js"
import style0 from "./GlobalNotificationsFloating.vue?vue&type=style&index=0&id=701a09e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a09e4",
  null
  
)

export default component.exports